const ETAPAS = [
  { nome: "Novo", tipo: "Entrada", cor: "#3b82f6" },
  { nome: "Em atendimento", tipo: "Aberto", cor: "#f5a50a" },
  { nome: "Proposta enviada", tipo: "Aberto", cor: "#8b5cf6" },
  { nome: "Aguardando retorno", tipo: "Aguardando", cor: "#82858f" },
  { nome: "Finalizado", tipo: "Finalizado", cor: "#25a55a" },
];

interface Props {
  id?: string;
  rotulo?: string;
  titulo: string;
  texto: string;
}

/**
 * A assinatura da pagina.
 *
 * Todo CRM desenha um funil, que tem fim. O cliente que compra de novo nao tem
 * fim: ele finaliza e volta. Entao aqui o desenho e um CICLO, e a seta de
 * retorno e a tese do produto.
 */
export function Ciclo({ id, rotulo = "O modelo", titulo, texto }: Props) {
  return (
    <section id={id} className="lp-secao">
      <p className="lp-rotulo lp-rotulo-ponto">{rotulo}</p>
      <h2 className="lp-secao-titulo">{titulo}</h2>
      <p className="lp-secao-texto">{texto}</p>

      <div className="lp-ciclo">
        <ol className="lp-ciclo-trilha">
          {ETAPAS.map((e) => (
            <li key={e.nome} className="lp-etapa">
              <span className="lp-etapa-ponto" style={{ background: e.cor }} aria-hidden />
              <span className="lp-etapa-nome">{e.nome}</span>
              <span className="lp-etapa-tipo">{e.tipo}</span>
            </li>
          ))}
        </ol>

        <div className="lp-retorno" aria-hidden>
          <svg className="lp-retorno-svg" viewBox="0 0 1000 86" preserveAspectRatio="none">
            <path
              className="lp-retorno-traco"
              d="M 910 0 L 910 44 Q 910 64 890 64 L 110 64 Q 90 64 90 44 L 90 8"
              vectorEffect="non-scaling-stroke"
            />
            <path d="M 90 0 L 84 12 L 96 12 Z" fill="#fe4f18" vectorEffect="non-scaling-stroke" />
          </svg>
          <span className="lp-retorno-rotulo">o cliente manda mensagem de novo</span>
        </div>

        <p className="lp-retorno-texto">
          ↑ Do Finalizado, volta para Novo quando o cliente manda mensagem de novo.
        </p>
      </div>
    </section>
  );
}
